import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TraceIdService {

    private currentTraceId: string = '';

    setTraceId(traceId: string): void {
        this.currentTraceId = traceId;
    }

    getCurrentTraceId(): string {
        return this.currentTraceId;
    }
}
